document.addEventListener('DOMContentLoaded', () => {
  function initializeModalButtons() {
    const modalButtons = document.querySelectorAll('[data-open-variant-modal]');

    modalButtons.forEach(button => {
      if (button.dataset.listenerAdded === 'true') return;
      button.dataset.listenerAdded = 'true';

      button.addEventListener('click', (event) => {
        event.preventDefault();
        const productId = button.dataset.productId;

        if (productId && window.openProductVariantModal) {
          window.openProductVariantModal(productId);
        }
      });
    });
  }

  initializeModalButtons();

  const observer = new MutationObserver(() => {
    initializeModalButtons();
  });

  document.querySelectorAll('product-recommendations').forEach(element => {
    observer.observe(element, {
      childList: true,
      subtree: true
    });
  });
});

